// extracted by mini-css-extract-plugin
export default {"books_container":"Category_books_container__NEa2O"};